import { useMemo } from 'react';

import { observer, useLocalObservable } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { DataTable } from 'components/DataTable';
import { configs } from 'jobboards/configs';
import { useStore } from 'models/Provider';

import { JobBoardLink } from './JobBoardLink';
import { TableWrap } from './TableWrap';

const RenderPrice = observer(({ item }) => {
  const { lang } = useStore();
  const config = configs[item.name];
  const texts = config[lang];
  return <span>{texts.priceText}</span>;
});

export const AvailableJobBoards = observer(({ boards, activate }) => {
  const { t } = useStore();
  const columns = useMemo(() => {
    return [
      {
        title: t('jobboards.table.jobboard'),
        render: (item) => <div>{configs[item.name].title}</div>,
      },
      { title: t('jobboards.table.price'), render: (item) => <RenderPrice item={item} /> },
      {
        title: t('jobboards.table.link'),
        render: (item) => <JobBoardLink link={configs[item.name].link} />,
      },
      {
        width: 0.5,
        style: { display: 'flex', justifyContent: 'flex-end' },
        render: (item) => <RenderConnectButton key={item.name} item={item} activate={activate} />,
      },
    ];
  }, [t, activate]);

  return (
    <Stack space={3}>
      <Text font="bold18" text={t('jobboards.settings.available')} />
      <TableWrap>
        <DataTable
          spacing={false}
          columns={columns}
          data={boards}
          rowStyle={{ background: 'transparent' }}
        />
      </TableWrap>
    </Stack>
  );
});

const RenderConnectButton = observer(({ item, activate }) => {
  const { t } = useStore();
  const state = useLocalObservable(() => ({
    submitting: false,
    setSubmitting(val) {
      state.submitting = val;
    },
    async submit() {
      state.setSubmitting(true);
      const success = await activate(item.name);
      if (!success) {
        state.setSubmitting(false);
      }
    },
  }));

  return (
    <>
      <Button
        isDisabled={state.submitting}
        onClick={state.submit}
        text={t('jobboards.settings.btn.connect')}
      />
    </>
  );
});
